import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import 'react-dropdown-tree-select/dist/styles.css'
import CallInitiate from './CallInitiation'
import CallIncomming from './CallIncomming'
import { withRouter } from 'react-router-dom'
import Ringing from '../../assets/Ringing/ringtone.mp3'
import Pushtocall from './Pushtocall';

var time_slot;
var audioObj;
class CallManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            to_caller_list: [],
            call_type: "video",
            calling_mode: "",      //INITIATE_CALL, INCOMMING_CALL
            room_id: this.props.room_id

        }
    }
    componentDidMount() {
        this.setState({ calling_mode: this.props.calling_mode });
        if (this.props.calling_mode == "INCOMMING_CALL") {
            // this.setState({ to_caller_list: this.props.to_calling_obj.callers });
            // this.callIncommingManager()
        }
        return

    }
    callIncommingManager = () => {
        if (time_slot) {
            clearTimeout(time_slot);
            if (audioObj) {
                audioObj.pause();
            }
        }
        if (audioObj) {
            audioObj.currentTime = 0;
            audioObj.play();
        }
        else {
            audioObj = new Audio(Ringing);
            audioObj.play();
        }
        time_slot = setTimeout(() => {
            audioObj.pause();
            this.props.callError()
        }, 20000);
    }
    componentWillReceiveProps(props) {
        if (props.calling_mode == "INCOMING_CALL") {
            // this.callIncommingManager()
        }
    }

    updateRoomId = (room_id) => {
        this.setState({ room_id: room_id })
        this.props.updateRoomId(room_id)
    }
    handleClick(room_id) {
        this.props.history.push(`/call/${room_id}`);
    }

    render() {
        if (this.state.calling_mode == "INITIATE_CALL") {
            if (this.state.room_id == 0) {
                return <CallInitiate updateCallers={this.props.updateCallers} callError={this.props.callError} to_calling_obj={this.props.to_calling_obj} updateRoomId={this.updateRoomId} callDecline={this.props.callDecline} />
            } else {
                return <Pushtocall room_id={this.state.room_id} />
            }
        } else if (this.state.calling_mode == "INCOMING_CALL") {
            return <CallIncomming callDecline={this.props.callDecline} callAccept={this.props.callAccept} incomming_data={this.props.incomming_data} to_calling_obj={this.props.to_calling_obj} />
        } else if (this.state.calling_mode == "ACCEPTED") {
            return <Pushtocall room_id={this.state.room_id} />
        } else return <div></div>
    }
}

export default withRouter(CallManager);


// import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../../assets/css/icons.css';
// import '../../assets/css/style.css'
// import 'react-dropdown-tree-select/dist/styles.css'
// import { SERVER_IP, PORT, PORT_webRTC, ud, logout } from '../../Server'
// import CallInitiate from './CallInitiation'
// import CallIncomming from './CallIncomming'
// import JoinCall from './CallAccepted'
// import Ringing from '../../assets/Ringing/ringtone.mp3'
// import Videocall from './Videocall';

// var time_slot;
// var audioObj;
// var socket;
// export default function Callmanager(props) {
//     const [to_caller_list, setTo_caller_list] = useState([])
//     const [call_type, setCall_type] = useState("video")
//     const [calling_mode, setCalling_mode] = useState("")
//     const [room_id, setRoom_id] = useState(props.room_id)

//     useEffect(() => {
//         setCalling_mode(props.calling_mode);
//         if (props.calling_mode == "INCOMMING_CALL") {
//             // this.setState({ to_caller_list: this.props.to_calling_obj.callers });
//             // this.callIncommingManager()
//         }

//         return () => {
//             if (props.calling_mode == "INCOMING_CALL") {
//                 // this.callIncommingManager()
//             }
//           }
//     }, [])

//     useEffect(() => {
//         if (socket === undefined) {
//             if (props.socket) {
//                 socket = props.socket;
//                 socket.on("live_users_list", function (data) {
//                 })
//             }
//         }
//     }, [props])

//     const callIncommingManager = () => {
//         if (time_slot) {
//             clearTimeout(time_slot);
//             if (audioObj) {
//                 audioObj.pause();
//             }
//         }
//         if (audioObj) {
//             audioObj.currentTime = 0;
//             audioObj.play();
//         }
//         else {
//             audioObj = new Audio(Ringing);
//             audioObj.play();
//         }
//         time_slot = setTimeout(() => {
//             audioObj.pause();
//             this.props.callError()
//         }, 20000);
//     }

//     const updateRoomId = (room_id) => {
//         setRoom_id(room_id)
//         props.updateRoomId(room_id)
//     }

//     return (
//         <>
//         {calling_mode=="INITIATE_CALL" && room_id==0
//         ? <CallInitiate updateCallers={props.updateCallers} callError={props.callError} callers={props.to_calling_obj.callers} updateRoomId={updateRoomId} callDecline={props.callDecline} />
//         : <Videocall room_id={room_id} />}

//         {calling_mode=="INCOMING_CALL" && <CallIncomming callDecline={this.props.callDecline} callAccept={this.props.callAccept} incomming_data={this.props.incomming_data} />}

//         {calling_mode=="ACCEPTED" && <Videocall room_id={room_id} />}
//         </>
//     )
// }